module.exports = __webpack_public_path__ + "static/media/empa-seeklogo.1445f679.png";